import React from "react";
// import * as Yup from "yup";
import { Formik, Form, Field, FieldArray } from "formik";
// import { Button } from "@mui/material";

import {
  FormMain,
  ErrorSpan,
  FileUploadWrap,
  InputFlexWrap,
  CargoDescription,
  // CustomDateTime,
  // DateTimeWrap,
} from "./styles/FormMainStyle";
import AuthInput from "../../shared/authinput";
// import MainButton from "../../shared/Button";
// import CloseIcon from "@mui/icons-material/Close";
// import fileupload from "../../../assets/images/fileupload.svg";
// import { ImageContainer } from "../../shared/commonstyle/ImagePreview";
import { formatDateTime } from "../../../helpers/DateFormate";
import NotFoundIcon from "../../shared/NotFoundIcon";

// const validationSchema = Yup.object().shape({
//   CargoName: Yup.string().required("Cargo name is required"),
//   Length: Yup.number().required("length is required"),
//   WidthLbs: Yup.number().required("Width is required"),
//   WidthIn: Yup.number().required("Width is required"),
//   HeightIn: Yup.number().required("Height is required"),
//   CargoImages: Yup.array().min(1, "Please select at least one image"),
//   DateTime: Yup.date().required("DateTime is required"),
//   CargoDescription: Yup.string().required("Cargo description  is required"),
// });

const OrderDetails = ({ data = {} }) => {
  // const [selectedImages, setSelectedImages] = useState([]);

  const handleSubmit = (values) => {
    console.log("values", values);
  };

  const initialValues = {
    CargoName: data?.order_detail?.name || "",
    WidthLbs: data?.order_detail?.weight || "",
    WidthIn: data?.order_detail?.width || "",
    HeightIn: data?.order_detail?.height || "",
    Length: data?.order_detail?.length || "",
    // CargoImages: [],
    DateTime: formatDateTime(data?.order_detail?.datetime || ""),
    CargoDescription: data?.order_detail?.description || "",
  };

  return (
    <FormMain className="customer__dateinputs">
      {data && Object?.keys(data)?.length > 0 ? (
        <>
          <Formik
            initialValues={initialValues}
            // validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <Form autocomplete="off">
                <Field
                  type="text"
                  name="CargoName"
                  label="Cargo"
                  component={AuthInput}
                  placeholder="Enter cargo name"
                  disabled
                />

                <InputFlexWrap className="DimensionsFlexWrap">
                  <Field
                    type="number"
                    name="WidthLbs"
                    label="Weight"
                    component={AuthInput}
                    placeholder="Weight"
                    inputMoreText="Lbs"
                    haveMoreText={true}
                    disabled
                  />
                  <Field
                    type="number"
                    name="Length"
                    label="Dimensions"
                    component={AuthInput}
                    placeholder="Length"
                    inputMoreText="In"
                    haveMoreText={true}
                    disabled
                  />
                  <Field
                    type="number"
                    name="WidthIn"
                    label=""
                    component={AuthInput}
                    placeholder="Width"
                    inputMoreText="In"
                    haveMoreText={true}
                    nolabel={true}
                    disabled
                  />
                  <Field
                    type="number"
                    name="HeightIn"
                    label=""
                    component={AuthInput}
                    placeholder="Height"
                    inputMoreText="In"
                    haveMoreText={true}
                    nolabel={true}
                    disabled
                  />
                </InputFlexWrap>

                {/* image and date time  */}

                <InputFlexWrap>
                  <FileUploadWrap className="FileUploadWrap">
                    <label>Cargo Image</label>
                    <div className="CargoImageImages">
                      {data &&
                        data?.order_detail?.image_urls.map((values) => {
                          return (
                            <>
                              <img src={values?.url} alt="" key={values?.id} />
                            </>
                          );
                        })}
                    </div>
                    {/* <Button
                  variant="contained"
                  component="label"
                  className="ButtonContainer"
                >
                  <span className="ButtonLabel">
                    Add your cargo image
                    <img src={fileupload} alt="fileupload" />
                  </span>

                  <FieldArray name="CargoImages">
                    {(arrayHelpers) => (
                      <input
                        type="file"
                        accept="image/*"
                        multiple
                        hidden
                        onChange={(event) =>
                          handleImageChange(event, arrayHelpers)
                        }
                      />
                    )}
                  </FieldArray>
                </Button>

                {formik.touched.CargoImages && formik.errors.CargoImages && (
                  <ErrorSpan className="errorSpan">
                    {formik.errors.CargoImages}
                  </ErrorSpan>
                )} */}
                  </FileUploadWrap>
                </InputFlexWrap>
                {/* End image and date time  */}

                {/* Cargo Description */}
                <InputFlexWrap>
                  {/* <DateTimeWrap>
                    <label>Date & Time</label>
                    <CustomDateTime
                      selected={formik.values.DateTime}
                      onChange={(date) =>
                        formik.setFieldValue("DateTime", date)
                      }
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      dateFormat="MM/dd/yyyy h:mm aa"
                      placeholderText="Select pickup date & time"
                      className="form-control"
                      popperProps={{
                        positionFixed: true, // use this to make the popper position: fixed
                      }}
                    />
                    {formik.touched.DateTime && formik.errors.DateTime && (
                      <ErrorSpan className="errorSpan">
                        {formik.errors.DateTime}
                      </ErrorSpan>
                    )}
                  </DateTimeWrap> */}
                  <Field
                    type="text"
                    name="DateTime"
                    label="Date & Time"
                    component={AuthInput}
                    placeholder="Date & Time"
                    disabled
                  />
                </InputFlexWrap>

                <CargoDescription
                  className={formik.errors.CargoDescription ? "haveBorder" : ""}
                >
                  <label>Cargo Description</label>
                  <Field
                    as="textarea"
                    name="CargoDescription"
                    placeholder="Enter cargo description"
                    disabled
                  />

                  {formik.touched.CargoDescription &&
                    formik.errors.CargoDescription && (
                      <ErrorSpan>{formik.errors.CargoDescription}</ErrorSpan>
                    )}
                </CargoDescription>

                {/*End Cargo Description */}
                {/* show the images */}
                {/* {selectedImages && (
              <ImageContainer className="ImageContainer">
                {selectedImages.map((file, index) => (
                  <div
                    key={index}
                    className="ImageItem"
                    style={{
                      backgroundImage: `url(${URL.createObjectURL(file)})`,
                    }}
                  >
                    <CloseIcon
                      className="RemoveIcon"
                      onClick={() =>
                        handleRemoveImage(index, formik.setFieldValue)
                      }
                    />
                  </div>
                ))}
              </ImageContainer>
            )} */}
                {/* End show the images */}

                {/* <MainButton type="submit" label="Edit Order Details" MT="110" /> */}
              </Form>
            )}
          </Formik>
        </>
      ) : (
        <NotFoundIcon MT="20" IconWidth="17" />
      )}
    </FormMain>
  );
};

export default OrderDetails;
